import { render, staticRenderFns } from "./tableProductsIAApproved.vue?vue&type=template&id=d84ffbc4&scoped=true"
import script from "./tableProductsIAApproved.vue?vue&type=script&lang=js"
export * from "./tableProductsIAApproved.vue?vue&type=script&lang=js"
import style0 from "./tableProductsIAApproved.vue?vue&type=style&index=0&id=d84ffbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ffbc4",
  null
  
)

export default component.exports